<!--PAGE-TOP-->
<app-header></app-header>
<!--/PAGE-TOP-->
<div class="i-page-content">
  <div class="container pb-5">
    <div class="row pt-3">
      <div class="col-12 text-center py-5">
        <h1 class="i-title">COMPARAÇÃO</h1>
      </div>
    </div>
    <div id="i-container-comparable" class="d-flex overflow-auto w-100">
      <ng-container *ngFor="let property of properties$ | async">
        <div class="i-box-comparable bg-light text-center p-3 mr-2">
          <div class="i-subtitle my-2">
            Cód. {{ property?.codigo }}
            <button
              *ngIf="property?.id"
              class="btn btn-link"
              [disabled]="removing"
              (click)="onRemove(property?.codigo)">
              <i class="iconify" data-icon="mdi-trash-can-outline"></i>
            </button>
          </div>
          <app-box [property]="property" [boxType]="BoxType.Expanded" [targetBlank]="true" [tags]="tags$ | async">
          </app-box>
          <button
            *ngIf="property?.id"
            class="i-btn i-btn-inverted mt-4"
            [disabled]="removing"
            (click)="onRemove(property?.codigo)">
            <i class="iconify" data-icon="mdi-trash-can-outline"></i> REMOVER
          </button>
        </div>
      </ng-container>
      <app-loading *ngIf="adding || removing"></app-loading>
      <div class="d-table i-box-comparable bg-light text-center p-3">
        <div class="i-subtitle">Adicionar imóvel</div>
        <div class="row p-4">
          <div class="input-group">
            <input
              name="codigo"
              type="text"
              class="form-control"
              placeholder="CÓDIGO"
              [(ngModel)]="codigo"
              mask="000000"
              (keyup.enter)="onAdd()" />
            <div class="input-group-append">
              <button type="button" class="btn btn-outline-secondary" [disabled]="adding" (click)="onAdd()">
                <span *ngIf="adding" class="spinner-border spinner-border-sm" role="status"></span>
                <i *ngIf="!adding"><i class="iconify" data-icon="mdi-plus"></i></i>
                <!-- ADICIONAR -->
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
